module.exports = __webpack_public_path__ + "img/left3.62d52fe8.png";